import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL und Anon Key müssen konfiguriert sein');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Auth Helper
export const auth = {
  signUp: async (email: string, password: string) => {
    return await supabase.auth.signUp({ email, password });
  },
  
  signIn: async (email: string, password: string) => {
    return await supabase.auth.signInWithPassword({ email, password });
  },
  
  signOut: async () => {
    return await supabase.auth.signOut();
  },
  
  getUser: async () => {
    return await supabase.auth.getUser();
  },
  
  onAuthStateChange: (callback: (event: string, session: any) => void) => {
    return supabase.auth.onAuthStateChange(callback);
  }
};

// Database Types
export interface Tenant {
  id: string;
  user_id: string;
  company_name: string;
  email: string;
  created_at: string;
  updated_at: string;
}

export interface TenantSettings {
  id: string;
  tenant_id: string;
  target_groups: string[];
  regions: string[];
  product_categories: string[];
  email_enabled: boolean;
  created_at: string;
  updated_at: string;
}

export interface Lead {
  id: string;
  tenant_id: string;
  name: string;
  category: string;
  city: string;
  website: string;
  email: string;
  status: string;
  opt_out: boolean;
  created_at: string;
  updated_at: string;
}

export interface WebsiteAnalysis {
  id: string;
  lead_id: string;
  nem_status: 'none' | 'recommendation' | 'active_use' | 'shop';
  structure_level: 'niedrig' | 'mittel' | 'hoch';
  entlastungspotenzial: 'gering' | 'mittel' | 'hoch';
  social_readiness: 'niedrig' | 'mittel' | 'hoch';
  kooperationseignung: 'niedrig' | 'mittel' | 'hoch';
  score: number;
  confidence: number;
  kurz_insight: string;
  evidence_urls: string[];
  signals_json: any;
  analysis_status: string;
  created_at: string;
  updated_at: string;
}

export interface SocialProfile {
  id: string;
  lead_id: string;
  platform: string;
  url: string;
  match_type: 'direct' | 'probable' | 'unknown';
  profile_type: 'Praxis' | 'Person' | 'unklar';
  activity: 'aktiv' | 'selten' | 'inaktiv' | 'unknown';
  tonality: 'fachlich' | 'edukativ' | 'persönlich' | 'marketinglastig' | 'unknown';
  bio_snippet: string;
  created_at: string;
  updated_at: string;
}

export interface OutreachDraft {
  id: string;
  lead_id: string;
  channel: string;
  subject: string;
  body: string;
  tone: string;
  focus: string;
  frames: string[];
  no_gos: string[];
  recommended: boolean;
  created_at: string;
  updated_at: string;
}
